<template>
  <div
    class="d-flex align-center white mt-n1 mb-2 py-2 px-4"
  >
    <v-checkbox
      v-model="localOnlyShowSuggest"
      class="my-2"
      :label="$t('eDocInternal.onlyShowCompletedPrefilled')"
      hide-details
    />
    <v-spacer />
    <v-dialog
      v-model="batchAgreeDialog"
      max-width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          v-bind="attrs"
          outlined
          :disabled="!onlyShowSuggest"
          small
          v-on="on"
        >
          {{ $t('eDocSuggest.batchProcess') }}
        </v-btn>
      </template>
      <v-card>
        <v-card-title>{{ $t('eDocSuggest.batchProcess') }}</v-card-title>
        <v-card-text>
          <v-checkbox
            v-model="agreeAllPrefilled"
            :label="$t('eDocSuggest.agreeAllPrefilled')"
            hide-details
            class="mb-1"
          />
          <div class="ml-8 mb-4 text-caption">
            {{ $t('eDocSuggest.batch.remarkMsg') }}
          </div>

          <!-- <v-select
            v-model="nextType"
            :label="$t('eDocSuggest.receiverType')"
            :items="nextTypes"
          />
          <s-search-staff
            v-if="nextType === 1"
            show-support-staff
            show-group
            :select.sync="nextEuid"
            :label="$t('eDocSuggest.receiver')"
          /> -->
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            color="primary"
            @click="batchAgreeDialog = false"
          >
            {{ $t('PublicServant.Action.Close') }}
          </v-btn>
          <v-btn
            :disabled="!agreeAllPrefilled || taskList.length === 0"
            color="primary"
            :loading="calling"
            @click="batchFinish"
          >
            <v-icon>{{ mdiSend }}</v-icon>
            {{ $t('eDocSuggest.action.send') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

import { mdiSend } from '@mdi/js'
import { globalModule } from '@/store/moduleName'
import docFlowApi from '@/api/eDocInternal/docFlow'
// import SSearchStaff from '@/components/SSearchStaff'

export default {
  components: {
    // SSearchStaff
  },
  props: {
    onlyShowSuggest: {
      type: Boolean,
      default: null
    },
    taskList: {
      type: Array,
      default: null
    }
  },
  data: function () {
    return {
      batchAgreeDialog: false,
      mdiSend: mdiSend,
      calling: false,
      agreeAllPrefilled: false
      // nextType: 2,
      // nextEuid: null
    }
  },
  computed: {
    localOnlyShowSuggest: {
      get: function () {
        return this.onlyShowSuggest
      },
      set: function (val) {
        this.$emit('update:onlyShowSuggest', val)
      }
    }
    /* nextTypes () {
      return [
        { value: 1, text: this.$t('eDocSuggest.nextType.toPerson') },
        { value: 2, text: this.$t('eDocSuggest.nextType.toEDoc') }
      ]
    } */
  },
  watch: {
  },
  methods: {
    batchFinish () {
      this.calling = true
      let processIds = []

      this.taskList.forEach(task => {
        processIds.push(task.dfProcessId)
      })

      let cb = resp => {
        this.calling = false
        if (resp.status === 201 || resp.status === 200) {
          this.batchAgreeDialog = false
          this.$store.dispatch(globalModule + '/setSnackbarMsg', this.$t('Training.Msg.SubmitSuccess'))
          this.$emit('finish')
        }
      }

      docFlowApi.batchFinishProcessByPrefilled(cb, processIds)
    }
  }

}
</script>
